module.exports = __webpack_public_path__ + "static/media/finance.fc2c3da7.png";